import {RETRIEVE_ADMIN_LIST} from '@/api'
import {CREATE_ADMIN} from '@/api'
import {GET_ADMIN_INFO} from '@/api'
import {EDIT_ADMIN} from '@/api'
import {DELETE_ADMIN} from '@/api'

export default {
  retrieveAdminList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('retrieveAdminList', {adminList: response.data.data.admin_list})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_ADMIN_LIST({}, successCallback, errorCallback)
  },

  createAdmin({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_info) {
        // commit('addStudentToList', {studentList: response.data.data.student_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_ADMIN({data: payload.data}, successCallback, errorCallback)
  },

  editAdmin({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_info) {
        commit('getAdminInfo', {adminInfo: response.data.data.admin_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_ADMIN({data: payload}, successCallback, errorCallback)
  },

  getAdminInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_info) {
        commit('getAdminInfo', {adminInfo: response.data.data.admin_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_ADMIN_INFO({payload}, successCallback, errorCallback)
  },

  deleteAdmin({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteAdmin', {adminInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_ADMIN({payload}, successCallback, errorCallback)
  }
};
